import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import extractHighlightedText from "@/view/AnnotationsContainer/AnnotationCard/AnnotationCardAnnotatedText/extractHighlightedText";
import ContentBodyAnnotatedTextAnchor from "@/view/ContentBodyAnnotatedTextAnchor";

const propTypes = {
  attrs: PropTypes.object,
  children: PropTypes.node,
  node: PropTypes.object,
};

const renderAnnotationAnchor = (annotation, node) => {
  if (!annotation.isStartInNode) return null;

  const highlightedText = extractHighlightedText(
    node,
    annotation,
    annotation.isStartInNode,
    annotation.isEndInNode,
  );

  // The anchor is added here rather than in ContentBodyAnnotatedText to avoid invalid nesting.
  // An anchor cannot be nested within an anchor.
  return (
    <ContentBodyAnnotatedTextAnchor
      annotation={annotation}
      key={annotation.id}
      text={highlightedText}
    />
  );
};

const ProseMirrorLinkMark = ({ children, attrs, node }) => (
  <>
    {node?.currentAnnotations?.map((annotation) =>
      renderAnnotationAnchor(annotation, node),
    )}

    <Anchor
      href={attrs?.href}
      dataProps={{ "data-identifier": node?.identifier }}
      isInline
    >
      {children}
    </Anchor>
  </>
);

ProseMirrorLinkMark.propTypes = propTypes;

export default ProseMirrorLinkMark;
